import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultGcTime: 0,
  parseSearch: (search) => Object.fromEntries(new URLSearchParams(search).entries()),
});
export type Router = typeof router;
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface StaticDataRouteOption {
    anonymous?: boolean;
    setupStep?: { number: number; titleKey?: string; subtitleKey?: string; canGoBack?: boolean };
  }

  interface HistoryState {
    [k: string]: unknown;
  }
}

// Helper type to extract params and search types for each route. This might be useful later. For now it's not used, only to extract paths.
export type Routes = {
  [k in keyof (typeof router)['routesByPath']]: {
    params: (typeof router)['routesByPath'][k]['types']['params'];
    search: (typeof router)['routesByPath'][k]['types']['fullSearchSchema'];
  };
};

export type Paths = keyof Routes;
